import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import SvgIcon from "@mui/material/SvgIcon";
import "./styles/project-file-structure.css";
import "./styles/project-files.css";

const glyphs = {
  acrobat: (
    <path
      d="M10.15 1.095C9.938.33 9.42-.051 8.984.005c-.528.068-1.09.382-1.314.876-.63 1.416.685 5.582.887 6.279-1.28 3.863-5.66 11.5-7.806 12.017-.045-.505.225-1.965 3.055-3.785.146-.157.315-.348.393-.472-2.392 1.168-5.492 3.044-3.628 4.448.102.079.259.146.439.213 1.426.528 3.425-1.201 5.435-5.121 2.213-.73 3.999-1.28 6.526-1.662 2.762 1.875 4.616 2.257 5.874 1.774.348-.135.898-.573 1.055-1.145-1.022 1.258-3.414.382-5.323-.82 1.763-.191 3.582-.303 4.369-.056 1 .314.965.808.954.876.079-.27.191-.708-.022-1.056-.842-1.37-4.706-.573-6.11-.427-2.212-1.336-3.74-3.717-4.358-5.436.573-2.212 1.19-3.818.742-5.413zm-.954 4.638C8.826 4.42 8.309 1.5 9.14.556c1.628.932.618 3.144.056 5.177zm3.044 6.514c-2.134.393-3.583.944-5.66 1.764.617-1.202 1.785-4.268 2.346-6.29.787 1.573 1.741 3.111 3.314 4.526z"
      transform="translate(14 9)"
      fillRule="evenodd"
    />
  ),
  document: (
    <path
      d="M12 4H0v2h12V4zM0 10h18V8H0v2zM0 0v2h18V0H0z"
      transform="translate(15 15)"
      fillRule="evenodd"
    />
  ),
  image: (
    <path
      d="M13 0L9.25 5l2.85 3.8-1.6 1.2C8.81 7.75 6 4 6 4l-6 8h22L13 0z"
      transform="translate(13 14)"
      fillRule="evenodd"
    />
  ),
  spreadsheet: (
    <path
      d="M0 8h6V5H0v3zm0 5h6v-3H0v3zM0 3h6V0H0v3zm8 5h12V5H8v3zm0 5h12v-3H8v3zM8 0v3h12V0H8z"
      transform="translate(14 14)"
      fillRule="evenodd"
    />
  ),
  auth2: (
    <path
      d="M0 0h18v2H0V0zm0 3h18v2H0V3zm0 3h18v2H0V6zm0 3h18v2H0V9zm0 3h18v2H0v-2z"
      transform="translate(14 15)"
      fillRule="evenodd"
    />
  ),
  DAQ: (
    <>
      <g>
        <path
          className="st0"
          d="M106.8,412.5h11.1c2.9,0,5.3.6,7.2,1.9s3.3,3.1,4.2,5.5c.9,2.4,1.4,5.2,1.4,8.5s-.5,6.2-1.4,8.6-2.3,4.3-4.2,5.6c-1.9,1.3-4.3,1.9-7.2,1.9h-11.1v-32ZM113.6,418.6v19.8h3.2c1.2,0,2.2-.2,3.1-.6s1.6-1,2.1-1.8c.6-.8,1-1.8,1.2-3.1s.4-2.7.4-4.3-.2-4-.7-5.5c-.5-1.5-1.2-2.6-2.2-3.3s-2.3-1.1-3.9-1.1h-3.2Z"
        />
        <path
          className="st0"
          d="M135.2,412.3c0-1.1.4-2.1,1.1-2.7.7-.7,1.7-1,2.9-1s2.1.3,2.8,1c.7.7,1.1,1.6,1.1,2.7s-.4,2-1.1,2.7c-.7.7-1.7,1-2.9,1s-2.1-.3-2.8-1c-.7-.7-1.1-1.6-1.1-2.7ZM135.8,444.5v-25h6.6v25h-6.6Z"
        />
        <path
          className="st0"
          d="M153.7,444.5l-7.1-25h7.2l3.6,18.4h.3l4.2-18.4h6.9l-7.5,25h-7.5Z"
        />
        <path
          className="st0"
          d="M172.1,412.3c0-1.1.4-2.1,1.1-2.7.7-.7,1.7-1,2.9-1s2.1.3,2.8,1c.7.7,1.1,1.6,1.1,2.7s-.4,2-1.1,2.7c-.7.7-1.7,1-2.9,1s-2.1-.3-2.8-1c-.7-.7-1.1-1.6-1.1-2.7ZM172.8,444.5v-25h6.6v25h-6.6Z"
        />
        <path
          className="st0"
          d="M184.9,427c0-1.9.4-3.5,1.3-4.6s2-2,3.4-2.5c1.4-.5,2.9-.8,4.6-.8s3.2.3,4.5.8,2.4,1.4,3.1,2.5,1.1,2.5,1.1,4.2h-5.8c0-.5-.2-.9-.4-1.3-.2-.4-.6-.7-1-1-.4-.3-1-.4-1.7-.4s-1.7.2-2.2.7c-.5.5-.8,1.1-.8,1.8s.2,1,.6,1.4c.4.4.9.6,1.5.8.6.2,1.2.4,1.9.5s1.3.2,1.9.3c1.4.2,2.5.7,3.5,1.2s1.8,1.3,2.3,2.3.8,2.2.8,3.7-.4,3.2-1.2,4.5c-.8,1.2-1.9,2.2-3.4,2.9-1.5.7-3.3,1-5.4,1s-3.7-.3-5.1-1-2.5-1.5-3.2-2.7c-.7-1.1-1.1-2.5-1.1-3.9h6.4c0,.5.2,1,.5,1.4.3.4.6.7,1.1.9.5.2,1.1.3,1.7.3s1.4-.1,1.8-.3.8-.5,1-.9.3-.8.3-1.3c0-.7-.3-1.3-.8-1.6s-1.2-.6-2-.8c-.8-.2-1.7-.4-2.6-.6-1.3-.3-2.5-.7-3.5-1.2-1.1-.5-1.9-1.3-2.5-2.3s-.9-2.3-.9-3.9Z"
        />
        <path
          className="st0"
          d="M208.1,412.3c0-1.1.4-2.1,1.1-2.7.7-.7,1.7-1,2.9-1s2.1.3,2.8,1c.7.7,1.1,1.6,1.1,2.7s-.4,2-1.1,2.7c-.7.7-1.7,1-2.9,1s-2.1-.3-2.8-1c-.7-.7-1.1-1.6-1.1-2.7ZM208.8,444.5v-25h6.6v25h-6.6Z"
        />
        <path
          className="st0"
          d="M231.1,419c2.1,0,4,.5,5.6,1.4s2.8,2.3,3.6,4.1,1.3,3.8,1.3,6.2v2.2c0,2.5-.4,4.7-1.3,6.5s-2.1,3.1-3.6,4.1-3.4,1.4-5.6,1.4-4-.5-5.6-1.4c-1.6-.9-2.8-2.3-3.6-4.1-.8-1.8-1.3-3.9-1.3-6.5v-2.2c0-2.3.4-4.4,1.3-6.2.9-1.8,2.1-3.2,3.6-4.1,1.6-1,3.4-1.5,5.6-1.5ZM231.1,424.6c-.9,0-1.6.3-2.2.9s-1,1.4-1.2,2.3c-.3.9-.4,2-.4,3v2.3c0,1,.1,2,.4,3,.2,1,.7,1.7,1.2,2.3.6.6,1.3.9,2.2.9s1.7-.3,2.2-.9c.6-.6.9-1.4,1.2-2.3s.4-1.9.4-3v-2.3c0-1.1-.1-2.1-.4-3.1-.3-.9-.7-1.7-1.2-2.3-.6-.6-1.3-.9-2.2-.9Z"
        />
        <path
          className="st0"
          d="M246.5,444.5v-25h6.4v4.3h.3c.2-.6.5-1.3,1-2.1.5-.7,1.2-1.4,2.1-1.9.9-.5,2-.8,3.4-.8,2.2,0,4,.7,5.3,2.2s2,3.7,2,6.7v16.5h-6.6v-14.6c0-1.2-.2-2.1-.5-2.8-.3-.7-.8-1.2-1.3-1.4s-1.1-.4-1.7-.4-1.4.2-2,.6-1,1-1.4,1.9c-.3.8-.5,1.8-.5,2.9v13.8h-6.6Z"
        />
        <path
          className="st0"
          d="M291.6,419c2.1,0,4,.5,5.6,1.4s2.8,2.3,3.6,4.1,1.3,3.8,1.3,6.2v2.2c0,2.5-.4,4.7-1.3,6.5s-2.1,3.1-3.6,4.1-3.4,1.4-5.6,1.4-4-.5-5.6-1.4c-1.6-.9-2.8-2.3-3.6-4.1-.8-1.8-1.3-3.9-1.3-6.5v-2.2c0-2.3.4-4.4,1.3-6.2.9-1.8,2.1-3.2,3.6-4.1,1.6-1,3.4-1.5,5.6-1.5ZM291.6,424.6c-.9,0-1.6.3-2.2.9s-1,1.4-1.2,2.3c-.3.9-.4,2-.4,3v2.3c0,1,.1,2,.4,3,.2,1,.7,1.7,1.2,2.3.6.6,1.3.9,2.2.9s1.7-.3,2.2-.9c.6-.6.9-1.4,1.2-2.3s.4-1.9.4-3v-2.3c0-1.1-.1-2.1-.4-3.1-.3-.9-.7-1.7-1.2-2.3-.6-.6-1.3-.9-2.2-.9Z"
        />
        <path
          className="st0"
          d="M308.7,444.5v-19.1h-3.6v-5.6h3.6v-2.5c0-2.5.6-4.4,1.8-5.5s3.3-1.7,6.2-1.7,1.2,0,1.9,0c.7,0,1.2.1,1.6.2v5.1c-.2,0-.5,0-.9,0-.4,0-.8,0-1.2,0-1,0-1.8.2-2.3.6-.5.4-.7,1.1-.7,2v1.8h4.9v5.6h-4.7v19.1h-6.5Z"
        />
        <path
          className="st0"
          d="M338.5,444.5h-6.8l9.1-32h8.3l9.1,32h-7.2l-1.8-7.4h-8.7l-1.8,7.4ZM345,419.4h-.3l-3,12.2h6.3l-3-12.2Z"
        />
        <path
          className="st0"
          d="M361.6,412.3c0-1.1.4-2.1,1.1-2.7s1.7-1,2.9-1,2.1.3,2.8,1,1.1,1.6,1.1,2.7-.4,2-1.1,2.7c-.7.7-1.7,1-2.9,1s-2.1-.3-2.8-1c-.7-.7-1.1-1.6-1.1-2.7ZM362.3,444.5v-25h6.6v25h-6.6Z"
        />
        <path
          className="st0"
          d="M375.2,444.5v-25h6.6v4h.3c.1-.6.4-1.2.8-1.9.4-.7,1-1.2,1.7-1.7.7-.5,1.6-.7,2.7-.7s.9,0,1.2,0,.6,0,.8.2v6.4c-.2,0-.6-.2-1-.2s-.9,0-1.4,0c-1.1,0-2.1.2-2.8.7-.7.5-1.3,1.1-1.6,1.9s-.5,1.8-.5,2.9v13.6h-6.8Z"
        />
        <path
          className="st0"
          d="M426.6,447.4h-6.5l-1.8-3c-.6.2-1.2.4-1.8.5-.6.1-1.3.2-2,.2-2.6,0-4.8-.6-6.7-1.8-1.9-1.2-3.3-2.9-4.3-5.2s-1.5-4.8-1.5-7.7v-3.6c0-3,.5-5.6,1.5-7.8s2.5-3.9,4.3-5.2c1.9-1.2,4.1-1.8,6.7-1.8s4.8.6,6.7,1.8,3.3,2.9,4.3,5.2c1,2.2,1.5,4.8,1.5,7.8v3.6c0,2.4-.3,4.5-1,6.5s-1.6,3.5-2.9,4.8l3.4,5.8ZM408.6,430.5c0,1.9.2,3.5.7,4.8s1.1,2.3,2,3,1.9,1.1,3,1.1c.2,0,.4,0,.6,0,.2,0,.4,0,.5-.2l-2.8-4.7h5.9c.2.2.3.5.5.7s.3.5.5.7c.3-.7.6-1.5.8-2.3.2-.9.3-1.9.3-3v-3.8c0-1.8-.2-3.4-.7-4.6-.5-1.3-1.2-2.2-2.1-2.9-.9-.7-1.9-1-3.1-1s-2.2.3-3.1,1c-.9.7-1.6,1.6-2.1,2.9-.5,1.3-.7,2.8-.7,4.6v3.8Z"
        />
        <path
          className="st0"
          d="M453,419.5v25h-6.4v-4.2h-.3c-.2.7-.6,1.3-1.1,2s-1.2,1.3-2.1,1.8c-.9.5-2,.7-3.3.7s-2.7-.3-3.8-.9c-1.1-.6-1.9-1.6-2.6-2.9s-.9-2.9-.9-4.9v-16.7h6.6v14.8c0,1.2.2,2.1.5,2.8s.8,1.1,1.3,1.3c.5.2,1.1.4,1.6.4s1.3-.2,1.9-.6,1-.9,1.4-1.6.5-1.5.5-2.5v-14.6h6.6Z"
        />
        <path
          className="st0"
          d="M465.1,444.9c-2.2,0-3.9-.7-5.3-2-1.4-1.4-2-3.2-2-5.6s.7-4.1,2-5.5c1.4-1.4,3.3-2.1,5.9-2.1h5.2v-2.1c0-1-.3-1.8-.8-2.3s-1.3-.8-2.2-.8-1.1.1-1.6.3c-.4.2-.8.5-1,.9s-.4.8-.4,1.3h-6.2c0-1,.2-2,.6-2.9s.9-1.8,1.6-2.6,1.7-1.4,2.8-1.8c1.2-.4,2.6-.7,4.3-.7s3.3.3,4.8.8c1.4.6,2.6,1.5,3.4,2.8.8,1.3,1.3,3,1.3,5.2v16.6h-6.2v-3.1h-.3c-.2.6-.6,1.1-1.1,1.6s-1.1,1-1.9,1.3c-.8.3-1.7.5-2.8.5ZM467.4,439.6c.6,0,1.2-.1,1.7-.4.5-.3,1-.7,1.3-1.2.3-.5.5-1.1.5-1.8v-2.4h-3.4c-1,0-1.8.3-2.4.8-.5.5-.8,1.2-.8,2.1s.3,1.7.9,2.2c.6.5,1.3.7,2.1.7Z"
        />
        <path className="st0" d="M483.3,444.5v-33.7h6.6v33.7h-6.6Z" />
        <path
          className="st0"
          d="M495.6,412.3c0-1.1.4-2.1,1.1-2.7s1.7-1,2.9-1,2.1.3,2.8,1,1.1,1.6,1.1,2.7-.4,2-1.1,2.7c-.7.7-1.7,1-2.9,1s-2.1-.3-2.8-1c-.7-.7-1.1-1.6-1.1-2.7ZM496.3,444.5v-25h6.6v25h-6.6Z"
        />
        <path
          className="st0"
          d="M510.7,419.8v-6.2h6.4v6.2h4.8v5.6h-4.8v10.6c0,1.1.2,1.9.7,2.3s1.2.6,2.2.6.8,0,1.1,0c.4,0,.6,0,.8,0v5.4c-.2,0-.7.1-1.4.2s-1.4.1-2.2.1c-1.9,0-3.4-.2-4.6-.7s-2-1.2-2.5-2.3c-.5-1.1-.8-2.5-.8-4.2v-11.9h-3.4v-5.6h3.5Z"
        />
        <path
          className="st0"
          d="M547.5,419.5c-.8,2.9-1.6,5.6-2.3,8.1s-1.4,4.9-2,6.9-1.1,3.9-1.6,5.4-.8,2.6-1,3.4l-.5,1.5c-1,3-2.3,5.2-3.9,6.5s-3.7,2-6.4,2-1.2,0-1.9,0-1.2-.1-1.5-.2v-5.2c.2,0,.5,0,.8.1.4,0,.7,0,1.1,0,1.2,0,2.2-.2,2.8-.8s1-1.3,1.1-2.4v-.5c0,0-7.3-24.9-7.3-24.9h7.3l4,18.9h.3l4.1-18.9h7Z"
        />
      </g>
      <image
        width="705"
        height="704"
        transform="translate(167.8 72.4) scale(.4)"
        // xlink:href="content-1.png"
      />
    </>
  ),
};

const customStyles = {
  pdf: {
    glyphColor: "rgb(240, 240, 240)",
    labelColor: "rgb(217, 54, 48)",
    foldColor: "rgba(168, 40, 35, 0.924)",
    labelTextColor: "rgb(240, 240, 240)",
    color: "rgb(217, 54, 48)",
    type: "acrobat",
  },
  doc: {
    color: "#2C5898",
    foldColor: "#254A80",
    glyphColor: "rgba(255,255,255,0.4)",
    labelColor: "#2C5898",
    labelUppercase: true,
    type: "document",
  },
  docx: {
    color: "#2C5898",
    foldColor: "#254A80",
    glyphColor: "rgba(255,255,255,0.4)",
    labelColor: "#2C5898",
    labelUppercase: true,
    type: "document",
  },
  png: {
    glyphColor: "rgba(185, 130, 42, 1)",
    labelColor: "rgba(185, 130, 42, 1)",
    labelTextColor: "rgba(185, 130, 42, 1)",
    color: "rgb(230, 230, 230)",
    foldColor: "rgba(182, 133, 54, 0.952)",
    type: "image",
  },
  jpg: {
    glyphColor: "rgba(185, 130, 42, 1)",
    labelColor: "rgba(185, 130, 42, 1)",
    labelTextColor: "rgba(185, 130, 42, 1)",
    color: "rgb(230, 230, 230)",
    foldColor: "rgba(182, 133, 54, 0.952)",
    type: "image",
  },
  jpeg: {
    glyphColor: "rgba(185, 130, 42, 1)",
    labelColor: "rgba(185, 130, 42, 1)",
    labelTextColor: "rgba(185, 130, 42, 1)",
    color: "rgb(230, 230, 230)",
    foldColor: "rgba(182, 133, 54, 0.952)",
    type: "image",
  },
  xls: {
    color: "#1A754C",
    foldColor: "#16613F",
    glyphColor: "rgba(255,255,255,0.4)",
    labelColor: "#1A754C",
    labelUppercase: true,
    type: "spreadsheet",
  },
  xlsx: {
    color: "#1A754C",
    foldColor: "#16613F",
    glyphColor: "rgba(255,255,255,0.4)",
    labelColor: "#1A754C",
    labelUppercase: true,
    type: "spreadsheet",
  },
  xlr: {
    color: "rgb(235, 235, 235)",
    glyphColor: "#1A754C",
    labelColor: "#1A754C",
    labelTextColor: "#1A754C",
    foldColor: "rgba(11, 85, 52, 0.941)",
    type: "spreadsheet",
  },
  csv: {
    color: "#1A754C",
    foldColor: "#16613F",
    glyphColor: "rgba(255,255,255,0.4)",
    labelColor: "#1A754C",
    labelUppercase: true,
    type: "spreadsheet",
  },
  missing_unknown: {
    color: "rgb(230, 230, 230)",
    glyphColor: "rgb(38, 139, 255)",
    labelColor: "rgb(38, 139, 255)",
    labelTextColor: "rgb(38, 139, 255)",
    foldColor: "rgba(190, 190, 190, 0.952)",
  },
  unknown: {
    color: "rgb(235, 235, 235)",
    glyphColor: "rgba(255, 255, 255, 0)",
    labelColor: "rgb(35, 35, 35)",
    labelTextColor: "rgb(235, 235, 235)",
    foldColor: "rgba(190, 190, 190, 0.952)",
  },
  required: {
    color: "rgb(235, 235, 235)",
    glyphColor: "rgb(200, 36, 36)",
    labelColor: "rgb(200, 36, 36)",
    labelTextColor: "rgb(235, 235, 235)",
    foldColor: "rgba(190, 190, 190, 0.952)",
  },
  DAQ: {
    // color: "rgb(10, 138, 155)",
    color: "rgb(191, 102, 24)",
    // color: "rgb(235, 235, 235)",
    glyphColor: "rgba(27, 43, 77, 0.393)",
    labelColor: "transparent",
    labelTextColor: "rgb(235, 235, 235)",
    foldColor: "rgba(190, 190, 190, 0.952)",
    type: "DAQ",
    labelUppercase: true,
  },
};

const ArgusFileIcon = ({
  color = "rgb(235, 235, 235)",
  extension,
  fold = true,
  foldColor = "rgba(165, 165, 165, 0.952)",
  glyphColor = "rgb(16, 114, 151)",
  gradientColor = "rgb(235, 235, 235)",
  gradientOpacity = 0.25,
  labelColor = "var(--argus-blue-dark)",
  labelTextColor = "rgb(235, 235, 235)",
  radius = "4",
  type,
  uniqueId,
}) => {
  const vb = {
    width: 40,
    height: 48,
  };

  const argusIcon = {
    width: vb.width,
    height: vb.height,
  };

  const foldHeight = {
    height: 12,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 48"
      width="100%"
      style={{
        maxWidth: "100%",
      }}
    >
      <defs>
        <clipPath id={`pageRadius${uniqueId}`}>
          <rect x="0" y="0" rx="4" width="40" height="48" />
        </clipPath>
        <clipPath id={`foldCrop${uniqueId}`}>
          <rect width="40" height="12" transform="rotate(-45, 0, 12)" />
        </clipPath>
        <linearGradient
          x1="100%"
          y1="0%"
          y2="100%"
          id={`pageGradient${uniqueId}`}
        >
          <stop
            stopColor={gradientColor}
            stopOpacity={gradientOpacity}
            offset="0%"
          />
          <stop stopColor={gradientColor} stopOpacity="0" offset="66.67%" />
        </linearGradient>
      </defs>

      <g id="file" clipPath={`url(#pageRadius${uniqueId})`}>
        {fold ? (
          <>
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={color}
            />
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        ) : (
          <>
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={color}
            />
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        )}
      </g>

      {fold && (
        <g transform={`translate(28 ${foldHeight.height}) rotate(-90)`}>
          <rect
            width={argusIcon.width}
            height={argusIcon.height}
            fill={foldColor}
            rx={radius}
            ry={radius}
            clipPath={`url(#foldCrop${uniqueId})`}
          />
        </g>
      )}

      {extension && (
        <>
          <g id={`label${uniqueId}`}>
            <rect
              fill={labelColor}
              x="0"
              y={argusIcon.height - 12}
              width={argusIcon.width}
              height={12}
              clipPath={`url(#pageRadius${uniqueId})`}
            />
          </g>
          <g id={`labelText${uniqueId}`} transform={`translate(0, 34)`}>
            <text
              x={argusIcon.width / 2}
              y="11"
              fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
              fontSize="8"
              fill={labelTextColor}
              textAnchor="middle"
              style={{
                fontWeight: "bold",
                textAlign: "center",
                pointerEvents: "none",
                textTransform:
                  extension === "docx" || extension === "doc"
                    ? "uppercase"
                    : "none",
                userSelect: "none",
              }}
            >
              {extension}
            </text>
          </g>
        </>
      )}

      {type == "admin" && (
        <g>
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="6px"
            viewBox="0 0 45 40"
            height="28"
          >
            <g>
              <path
                fill="#231F20"
                stroke="#231F20"
                strokeMiterlimit="10"
                d="M19.57,5.94L5.77,33.66l17.34,0.02
        c-4.03-3.25-4.67-9.46-1.95-14.49L28.6,5.94H19.57z"
              />
              <path
                fill="none"
                stroke="#231F20"
                strokeMiterlimit="10"
                d="M30.56,34.06"
              />
              <path
                fill="none"
                stroke="#231F20"
                strokeMiterlimit="10"
                d="M22.95,20.66"
              />
              <path
                fill="none"
                stroke="#231F20"
                strokeMiterlimit="10"
                d="M38.01,21"
              />
              <linearGradient
                id="SVGID_1_"
                gradientUnits="userSpaceOnUse"
                x1="37.4634"
                y1="28.3434"
                x2="24.6532"
                y2="17.5794"
              >
                <stop offset="6.13%" stopColor="#066D94" />
                <stop offset="41.35%" stopColor="#5A93B4" />
                <stop offset="79.66%" stopColor="#92C5DD" />
                <stop offset="97.78%" stopColor="#ABE0F2" />
              </linearGradient>
              <path
                fill="url(#SVGID_1_)"
                d="M29.9,7.3l-7.44,13.36c-0.58,1.19-0.91,2.13-1.02,2.87c-0.3,1.58-0.18,3.11,0.25,4.62
        c0.54,1.57,1.34,2.76,2.38,3.61c1.79,1.65,3.81,2.3,6,2.3c1.45,0,2.87-0.36,4.25-1.23c0.97-0.59,1.82-1.37,2.53-2.37
        c0.76-1.02,1.26-2,1.51-3.3c0.24-1.25,0.26-2.25,0.12-3.32c-0.15-0.97-0.48-1.91-0.96-2.84L29.9,7.3z"
              />
            </g>
          </svg>
        </g>
      )}
    </svg>
  );
};

const AuthorizationLetterIcon = ({
  color = "rgb(10, 138, 155)",
  extension = "DAQ",
  fold = false,
  foldColor = "rgba(165, 165, 165, 0.952)",
  glyphColor = "rgb(16, 114, 151)",
  gradientColor = "rgb(235, 235, 235)",
  gradientOpacity = 0,
  labelColor = "var(--argus-blue-dark)",
  labelTextColor = "rgb(235, 235, 235)",
  radius = "4",
  type,
  uniqueId,
}) => {
  const vb = {
    width: 40,
    height: 48,
  };

  const argusIcon = {
    width: vb.width,
    height: vb.height,
  };

  const foldHeight = {
    height: 12,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 48"
      width="100%"
      style={{
        maxWidth: "100%",
      }}
    >
      <defs>
        <clipPath id={`pageRadius${uniqueId}`}>
          <rect x="0" y="0" rx="4" width="40" height="48" />
        </clipPath>
        <clipPath id={`foldCrop${uniqueId}`}>
          <rect width="40" height="12" transform="rotate(-45, 0, 12)" />
        </clipPath>
        <linearGradient
          x1="100%"
          y1="0%"
          y2="100%"
          id={`pageGradient${uniqueId}`}
        >
          <stop
            stopColor={gradientColor}
            stopOpacity={gradientOpacity}
            offset="0%"
          />
          <stop stopColor={gradientColor} stopOpacity="0" offset="66.67%" />
        </linearGradient>
      </defs>

      <g id="file" clipPath={`url(#pageRadius${uniqueId})`}>
        {fold ? (
          <>
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={color}
            />
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        ) : (
          <>
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={color}
            />
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        )}
      </g>
      {type === "DAQ" && (
        <image
          x="1.5"
          y="6"
          width="37"
          height="37"
          href="/icons/cc-logo-png.png"
          style={{
            filter: "drop-shadow(0px 1px 1.5px rgba(0, 50, 55, 0.585))",
          }}
        />
      )}
    </svg>
  );
};

const FileTypeIcon = ({
  color = "rgb(235, 235, 235)",
  extension,
  fold = true,
  foldColor = "rgba(190, 190, 190, 0.952)",
  glyphColor,
  gradientColor = "rgb(235, 235, 235)",
  gradientOpacity = 0.25,
  labelColor,
  labelTextColor = "rgb(235, 235, 235)",
  labelUppercase = false,
  radius = 4,
  type,
  uniqueId,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 48"
      width="100%"
      style={{
        maxWidth: "100%",
      }}
    >
      <defs>
        <clipPath id={`pageRadius${uniqueId}`}>
          <rect x="0" y="0" rx={radius} ry={radius} width="42" height="48" />
        </clipPath>

        <clipPath id={`foldCrop${uniqueId}`}>
          <rect width="42" height="14" transform={`rotate(-45, 0, 14)`} />
        </clipPath>

        <linearGradient
          x1="100%"
          y1="0%"
          y2="100%"
          id={`pageGradient${uniqueId}`}
        >
          <stop
            stopColor={gradientColor}
            stopOpacity={gradientOpacity}
            offset="0%"
          />
          <stop stopColor={gradientColor} stopOpacity="0" offset="66.67%" />
        </linearGradient>
      </defs>

      <g id="file" clipPath={`url(#pageRadius${uniqueId})`}>
        {fold ? (
          <>
            <path d="M0 0 h 28 L 42 14 v 34 H 0 Z" fill={color} />
            <path
              d="M0 0 h 28 L 42 14 v 34 H 0 Z"
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        ) : (
          <>
            <rect x="0" y="0" width="42" height="48" fill={color} />
            <rect
              x="0"
              y="0"
              width="42"
              height="48"
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        )}
      </g>
      {fold && (
        <>
          <g transform={`translate(28 14) rotate(-90)`}>
            <rect
              width="42"
              height="48"
              fill={foldColor}
              rx={radius}
              ry={radius}
              clipPath={`url(#foldCrop${uniqueId})`}
            />
          </g>
        </>
      )}

      {extension && (
        <>
          <g id={`label${uniqueId}`}>
            <rect
              fill={labelColor}
              x="0"
              y="-22" //Could be 28
              width="42"
              height="14"
              clipPath={`url(#pageRadius${uniqueId})`}
            />
          </g>

          <g id={`labelText${uniqueId}`} transform={`translate(0, 34)`}>
            <text
              x="21"
              y="10"
              fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
              fontSize="9"
              fill={labelTextColor}
              textAnchor="middle"
              style={{
                fontWeight: "bold",
                textAlign: "center",
                pointerEvents: "none",
                textTransform: labelUppercase ? "uppercase" : "none",
                userSelect: "none",
              }}
            >
              {extension}
            </text>
          </g>
        </>
      )}

      {type && glyphs[type] && (
        <g transform={`translate(-4 ${!extension ? 6 : 0})`} fill={glyphColor}>
          {glyphs[type]}
        </g>
      )}
    </svg>
  );
};

const BlankFileIcon = ({
  color = "rgb(235, 235, 235)",
  extension,
  fold = true,
  foldColor = "rgba(190, 190, 190, 0.952)",
  glyphColor = "transparent",
  gradientColor = "rgb(235, 235, 235)",
  gradientOpacity = 0.25,
  labelColor = "rgb(235, 235, 235)",
  labelTextColor = "rgb(206, 33, 33)",
  radius = "4",
  type,
  uniqueId,
}) => {
  const vb = {
    width: 42,
    height: 48,
  };

  const argusIcon = {
    width: vb.width,
    height: vb.height,
  };

  const foldHeight = {
    height: 14,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 48"
      width="100%"
      style={{
        maxWidth: "100%",
      }}
    >
      <defs>
        <clipPath id={`pageRadius${uniqueId}`}>
          <rect x="0" y="0" rx="4" width="42" height="48" />
        </clipPath>
        <clipPath id={`foldCrop${uniqueId}`}>
          <rect
            width="42"
            height={foldHeight.height}
            transform={`rotate(-45, 0, ${foldHeight.height})`}
          />
        </clipPath>
        <linearGradient
          x1="100%"
          y1="0%"
          y2="100%"
          id={`pageGradient${uniqueId}`}
        >
          <stop
            stopColor={gradientColor}
            stopOpacity={gradientOpacity}
            offset="0%"
          />
          <stop stopColor={gradientColor} stopOpacity="0" offset="66.67%" />
        </linearGradient>
      </defs>

      <g id="file" clipPath={`url(#pageRadius${uniqueId})`}>
        {fold ? (
          <>
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={color}
            />
            <path
              d={`M0 0 h ${argusIcon.width - foldHeight.height} L ${
                argusIcon.width + 0
              } ${foldHeight.height} v ${
                argusIcon.height - foldHeight.height
              } H 0 Z`}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        ) : (
          <>
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={color}
            />
            <rect
              x="0"
              y="0"
              width={argusIcon.width}
              height={argusIcon.height}
              fill={`url(#pageGradient${uniqueId})`}
            />
          </>
        )}
      </g>

      {fold && (
        <g transform={`translate(28 ${foldHeight.height}) rotate(-90)`}>
          <rect
            width={argusIcon.width}
            height={argusIcon.height}
            fill={foldColor}
            rx={radius}
            ry={radius}
            clipPath={`url(#foldCrop${uniqueId})`}
          />
        </g>
      )}

      {type === "required" && (
        <>
          <g id={`label${uniqueId}`}>
            <rect
              fill={labelColor}
              x="0"
              y={argusIcon.height - 14}
              width={argusIcon.width}
              height={15}
              clipPath={`url(#pageRadius${uniqueId})`}
            />
          </g>
          <g id={`labelText${uniqueId}`}>
            <text
              id="required-extension-text"
              className="required-extension-text"
              // fontSize={8}
              x={argusIcon.width / 2}
              y={argusIcon.height - 4}
              textAnchor="middle"
              textLength={"90%"}
              style={{
                color: labelTextColor,
              }}
            >
              {"Required"}
            </text>
          </g>
        </>
      )}

      {type === "unknown" && (
        <>
          <g id={`label${uniqueId}`}>
            <rect
              fill={labelColor}
              x="0"
              y={argusIcon.height - 14}
              width={argusIcon.width}
              height={14}
              clipPath={`url(#pageRadius${uniqueId})`}
            />
          </g>
          <g id={`labelText${uniqueId}`} transform={`translate(0, 34)`}>
            <text
              x={argusIcon.width / 2}
              y="10"
              fontSize={8}
              textAnchor="middle"
              style={{
                color: labelTextColor,
                fontWeight: "bold",
              }}
            >
              {"No File"}
            </text>
          </g>
        </>
      )}
      {type === "required" && (
        <g>
          <SvgIcon
            className="required-file-svg"
            id="required-file-svg"
            color={glyphColor}
            htmlColor={glyphColor}
            viewBox="-9 -4 40 40"
            fontSize="medium"
            style={{
              transform: "scale(1) !important",
            }}
            sx={{
              fontSize: "14px",
              fill: glyphColor,
              height: "20px",
              width: "20px",
            }}
            inheritViewBox={false}
            classes={{
              root: "required-file-svg-root",
              fontSizeSmall: "required-file-svg-fontSizeSmall",
            }}
          >
            <WarningRoundedIcon
              className="required-file-icon"
              id="required-file-icon"
              classes={{
                root: "required-file-icon-root",
                fontSizeSmall: "required-file-icon-fontSizeSmall",
              }}
              fontSize="small"
              style={{
                transform: "scale(0.75) !important",
              }}
              sx={{
                fontSize: "10px",
                fill: glyphColor,
                height: "15px",
                width: "12px",
                scale: "75% !important",
                transform: "scale(0.75) !important",
              }}
            />
          </SvgIcon>
        </g>
      )}
    </svg>
  );
};

export {
  ArgusFileIcon,
  AuthorizationLetterIcon,
  BlankFileIcon,
  customStyles,
  FileTypeIcon,
};
